import { useCallback, useState } from 'react';
import { useMainStackRoute } from 'utils/types/navigationV6';
export const useContactInvite = () => {
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [selectedContactsObj, setSelectedContactsObj] = useState({});
    const route = useMainStackRoute();
    const removeFromSelected = useCallback((item) => {
        const { handle } = item;
        if (handle) {
            setSelectedContactsObj((oldState) => ({
                ...oldState,
                [handle]: undefined,
            }));
            setSelectedContacts(selectedContacts.filter((value) => value.handle !== handle));
        }
    }, [selectedContacts]);
    const onPressInvite = useCallback((data) => {
        const canAdd = route?.params?.allowToAddAnyContact || data?.isEmmaUser;
        const { handle } = data;
        if (canAdd && handle && selectedContactsObj[handle]) {
            removeFromSelected(data);
        }
        else if (canAdd && handle) {
            setSelectedContactsObj((oldState) => ({
                ...oldState,
                [handle]: data,
            }));
            setSelectedContacts([...selectedContacts, data]);
        }
    }, [
        removeFromSelected,
        route?.params?.allowToAddAnyContact,
        selectedContacts,
        selectedContactsObj,
    ]);
    return {
        onPressInvite,
        selectedContacts,
        removeFromSelected,
        selectedContactsObj,
    };
};
